"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartOrEndEnum = void 0;
const zod_1 = require("zod");
const startOrEndCases = ['start', 'end'];
exports.StartOrEndEnum = zod_1.z.enum(startOrEndCases);
